export default __webpack_public_path__ + "static/menu-tachibanaudon-min2-8a08b43600cf080a38530b81c9b64f4a.jpg";